import { hash } from 'immutable';
import { combineActions, handleActions } from 'redux-actions';

import { resourceUpserters } from 'app-components/flux/core';
import { coreActions } from 'app-components/flux/core-actions';

import * as actions from './actions';
import {
  FUNDING_ACCOUNTS_REDUCER_KEY,
  type FundingAccountStore,
  mkFundingAccount,
  mkFundingAccountStore,
} from './types';

const fundingAccountsReducer = handleActions<
  FundingAccountStore,
  | coreActions.SanitizeAction
  // get
  | ReturnType<typeof actions.getFundingAccounts>
  | ReturnType<typeof actions.getFundingAccountsSuccess>
  | ReturnType<typeof actions.getFundingAccountsFailure>
  // create
  | ReturnType<typeof actions.createFundingAccountSuccess>
  | ReturnType<typeof actions.createFundingAccountFailure>
  // delete
  | ReturnType<typeof actions.deleteFundingAccountSuccess>
>(
  {
    [coreActions.SANITIZE]: (state) =>
      state.set(
        'resourcesById',
        state.resourcesById.map((resource) =>
          resource.mergeDeep(
            mkFundingAccount({
              // hash the PII
              routingNumber: hash(resource?.routingNumber).toString(),
              accountNumber: hash(resource?.accountNumber).toString(),
              nickname: hash(resource?.nickname).toString(),
            }),
          ),
        ),
      ),

    [actions.getFundingAccounts.type]: (state) => state.merge({ isLoading: true }),
    [actions.getFundingAccountsSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResources(state, { resources: payload }),

    [actions.getFundingAccountsFailure.type]: (state, { payload: error }) =>
      // @ts-expect-error (ts-2345)
      // store conflict with baseResource - (will resolve once moved to app-components)
      resourceUpserters.completeWithError(state, error),

    [actions.createFundingAccountSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResource(state, payload),

    [actions.deleteFundingAccountSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResource(state, payload),

    [combineActions(
      actions.createFundingAccountFailure,
      // actions.updateFundingAccountFailure,
      // actions.deleteFundingAccountFailure,
    ).toString()]: (state: FundingAccountStore, { payload: error, asyncDispatch }: any) => {
      asyncDispatch(actions.getFundingAccounts());
      // @ts-expect-error (ts-2345)
      // store conflict with baseResource - (will resolve once moved to app-components)
      return resourceUpserters.resetResources(state, error);
    },
  },
  mkFundingAccountStore(),
);

export { FUNDING_ACCOUNTS_REDUCER_KEY };

export default fundingAccountsReducer;
